import { apiCall } from "./Interceptor";

const COMPANY_LIST = "/access/getAll";
const MODIFY_ACCESS = "/access/modify";

const getAllcompanyList = async () => {
  const response = await apiCall.get(COMPANY_LIST);
  return response;
};
const modifyRoleAccess = async ( data) => {
  const response = await apiCall.put(MODIFY_ACCESS, data);
  return response;
};

export default {
  getAllcompanyList,
  modifyRoleAccess,
};
